// material-ui
import { useTheme } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';

// assets
import logoCityOptima from 'assets/images/logo/cityoptima_svg.svg';
import logoCityOptimaLight from 'assets/images/logo/logo-CityOptima-L.png';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain({ reverse }: { reverse?: boolean }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === ThemeMode.DARK;
  const imgSrc = logoCityOptima;

  return <img src={imgSrc} alt="AssetFront" width="240" style={{ display: 'block' }} />;
}
